import { LocationServiceConfig } from '../types';
import { SimpleAgentEntity } from '../types/agents.types';
import {
  AgentDetailsResponse,
  SalesPreferences,
} from '../types/api/agents.types';
import { PaginationParams, ResponseType } from '../types/shared.types';
import { SimpleUserEntity } from '../types/user.types';
import { api } from './api';

export const uprateAgentFlatMountByUser = (
  userId: string | number,
  amountPerLocation: number | null
) =>
  api.put<ResponseType<AgentDetailsResponse>>(
    `/v1/agents/${userId}/update-flat-amount`,
    { amountPerLocation }
  );

export const updateAgentPendingBalance = (
  userId: string | number,
  data: {
    amount: number;
    adminPassword: string;
    reason: string;
  }
) =>
  api.put<ResponseType<AgentDetailsResponse>>(
    `/v1/agents/${userId}/update-pending-balance`,
    data
  );

export const verifyAgent = (
  agentId: string | number
  // amountPerLocation?: number
) =>
  api.post<ResponseType<null>>(`/v1/agents/${agentId}`, {
    // TODO ACA: Uncomment this when we have a way to set amountPerLocation
    // amountPerLocation: amountPerLocation ?? null,
  });

export const rejectVerificationAgent = (
  agentId: string | number,
  reason: string
) =>
  api.post<ResponseType<null>>(`/v1/agents/${agentId}/reject-verification`, {
    reason,
  });

export const getAllSignedVerifiedAgents = (
  userId: string | number,
  params: PaginationParams<{
    query?: string;
  }>
) =>
  api.get<ResponseType<Array<LocationServiceConfig>>>(
    `/v1/agents/${userId}/locations`,
    {
      params,
    }
  );

export const getAgentLocationsV2 = (
  userId: string | number,
  params: PaginationParams<{
    query?: string;
  }>
) =>
  api.get<ResponseType<Array<LocationServiceConfig>>>(
    `/v2/agents/${userId}/locations`,
    {
      params,
    }
  );

export const getFilledW9Form = (agentId: string | number) =>
  api.get<ResponseType<string>>(`/v1/agents/${agentId}/filled-w9-form`);

export const getAllUnverifiedAndCompletedAgents = (
  params: PaginationParams<{ query?: string }>
) =>
  api.get<ResponseType<Array<SimpleUserEntity>>>(`/v1/agents/all`, {
    params,
  });

export const getAllVerifiedAgents = (
  params: PaginationParams<{
    query?: string;
  }>
) =>
  api.get<ResponseType<Array<SimpleUserEntity>>>(`/v1/agents/all-verified`, {
    params,
  });

export const getAllDirectAgentChildren = (
  agentId: string | number,
  params: PaginationParams<{ query?: string }>
) =>
  api.get<ResponseType<SimpleAgentEntity[]>>(
    `/v1/agents/${agentId}/direct-childs`,
    { params }
  );

export const getAgentDetails = (userId: string | number) =>
  api.get<ResponseType<AgentDetailsResponse>>(`/v1/agents`, {
    params: {
      userId,
    },
  });

export const updateAgentReferralPercentage = (
  agentId: string | number,
  percentage: number
) =>
  api.put<ResponseType<null>>(`/v1/agents/${agentId}/referral/v2`, {
    percentage,
  });

export const activateChildAgent = (userId: string | number) =>
  api.put<ResponseType<null>>(`/v1/agents/activate`, null, {
    params: {
      userId,
    },
  });

export const deactivateChildAgent = (userId: string | number) =>
  api.put<ResponseType<null>>(`/v1/agents/deactivate`, null, {
    params: {
      userId,
    },
  });

export const getSalesPreferences = () =>
  api.get<ResponseType<SalesPreferences>>(`/v1/agents/preferences`);
